// extracted by mini-css-extract-plugin
export default {"loading":"Payment_loading__xTPbw"};